import type { RecurringProServiceStatus } from 'maintenance/types';

export const STYLES_BY_STATUS: Record<RecurringProServiceStatus, string> = {
  off: 'bg-red-translucent border-red',
  on: 'bg-green-translucent border-green',
};
